import React, { useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useTranslation, Trans } from 'react-i18next';
import LanguageSwitcher from '../../Component/LanguageSwitcher';

const SeniorCS = () => {
    const { t } = useTranslation('SeniorCS');

    useEffect(() => {
        document.title = t('title');
        const metaDesc = document.querySelector('meta[name="description"]');
        if (metaDesc) {
            metaDesc.setAttribute('content', t('metaDescription'));
        }
    }, [t]);

    return (
        <div>
            <header className="d-flex justify-content-end align-items-center p-3 border-bottom">
                <LanguageSwitcher />
            </header>

            <div className="webview">
                <Container>
                    <Row>
                        <Col xs={12}>
                            {/* Intro */}
                            <Trans
                                i18nKey="content.intro"
                                ns="SeniorCS"
                                components={[
                                    <strong key="0" />,
                                    <a
                                        key="1"
                                        href="https://www.goodreturns.in/classroom/2012/11/all-about-senior-citizen-savings-scheme-154769.html"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    />,
                                    <strong key="2" />
                                ]}
                            />
                            <br />
                            <br />
                       
                            {/* Extension */}
                            <Trans
                                i18nKey="content.extension"
                                ns="SeniorCS"
                                components={[
                                    <strong key="0" />,
                                    <a
                                        key="1"
                                        href="https://www.goodreturns.in/personal-finance/investment/4-best-investment-options-for-senior-citizens-1161687.html"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    />
                                ]}
                            />

                            {/* Eligibility */}
                            <h2><Trans i18nKey="content.eligibility.heading" ns="SeniorCS" /></h2>
                            <Trans i18nKey="content.eligibility.description" ns="SeniorCS" />
                            <br />
                            <br />
                            <ul>
                                {t('content.eligibility.list', { returnObjects: true }).map((_, index) => (
                                    <li key={index}>
                                        <Trans
                                            i18nKey={`content.eligibility.list.${index}`}
                                            ns="SeniorCS"
                                            components={index === 6 ? [<strong key="0" />] : []}
                                        />
                                    </li>
                                ))}
                            </ul>

                            {/* Documents */}
                            <h2><Trans i18nKey="content.documents.heading" ns="SeniorCS" /></h2>
                            <Trans i18nKey="content.documents.description" ns="SeniorCS" />
                           <br /><br />
                            <ul>
                                {t('content.documents.list', { returnObjects: true }).map((item, index) => (
                                    <li key={index}>
                                        <Trans
                                            i18nKey={`content.documents.list.${index}`}
                                            ns="SeniorCS"
                                            components={
                                                index === 0 ? [
                                                    <a
                                                        key="0"
                                                        href="https://www.goodreturns.in/aadhar-card.html"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    />
                                                ] : index === 3 ? [
                                                    <a
                                                        key="1"
                                                        href="https://www.goodreturns.in/pan-card.html"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    />
                                                ] : []
                                            }
                                        />
                                    </li>
                                ))}
                            </ul>

                            {/* Banks */}
                            <h2><Trans i18nKey="content.banks.heading" ns="SeniorCS" /></h2>
                            <Trans
                                i18nKey="content.banks.description"
                                ns="SeniorCS"
                                components={[<strong key="0" />]}
                            />
                            <br /><br />
                            <ul>
                                {t('content.banks.list', { returnObjects: true }).map((item, index) => (
                                    <li key={index}>{item}</li>
                                ))}
                            </ul>

                            {/* Features */}
                            <h2><Trans i18nKey="content.features.heading" ns="SeniorCS" /></h2>
                            
                            <Trans i18nKey="content.features.description" ns="SeniorCS" />
                            <br /><br />
                            <ul>
                                {t('content.features.points', { returnObjects: true }).map((_, index) => (
                                    <li key={index}>
                                        <Trans
                                            i18nKey={`content.features.points.${index}`}
                                            ns="SeniorCS"
                                            components={[<strong key="0" />]}
                                        />
                                        <br />
                                        <br />
                                    </li>
                                ))}
                            </ul>

                            {/* Deposit Limits */}
                            <h2><Trans i18nKey="content.depositLimits.heading" ns="SeniorCS" /></h2>
                            <Trans i18nKey="content.depositLimits.description" ns="SeniorCS" />

                            {/* Application Form */}
                            <h2><Trans i18nKey="content.applicationForm.heading" ns="SeniorCS" /></h2>
                            <Trans
                                i18nKey="content.applicationForm.description"
                                ns="SeniorCS"
                                components={[<strong key="0" />]}
                            />
                            <ul>
                                {t('content.applicationForm.process', { returnObjects: true }).map((item, index) => (
                                    <li key={index}>{item}</li>
                                ))}
                            </ul>

                            {/* Registration at Banks */}
                            <h2><Trans i18nKey="content.registrationBanks.heading" ns="SeniorCS" /></h2>
                            <br />
                         
                            <Trans i18nKey="content.registrationBanks.description" ns="SeniorCS" />
                            <ul>
                                {t('content.registrationBanks.list', { returnObjects: true }).map((item, index) => (
                                    <li key={index}>{item}</li>
                                ))}
                            </ul>

                            {/* Premature Withdrawal */}
                            <h2><Trans i18nKey="content.withdrawal.heading" ns="SeniorCS" /></h2>
                            <Trans i18nKey="content.withdrawal.description" ns="SeniorCS" />
                            <ul>
                                {t('content.withdrawal.list', { returnObjects: true }).map((item, index) => (
                                    <li key={index}>{item}</li>
                                ))}
                            </ul>

                            {/* Tax */}
                            <h2><Trans i18nKey="content.tax.heading" ns="SeniorCS" /></h2>
                            <ul>
                                {t('content.tax.points', { returnObjects: true }).map((item, index) => (
                                    <li key={index}>{item}</li>
                                ))}
                            </ul>

                            {/* Calculation */}
                            <h2><Trans i18nKey="content.calculation.heading" ns="SeniorCS" /></h2>
                            <Trans i18nKey="content.calculation.description" ns="SeniorCS" />

                            {/* Tax Provisions */}
                            <h2><Trans i18nKey="content.taxProvisions.heading" ns="SeniorCS" /></h2>
                            <Trans i18nKey="content.taxProvisions.description" ns="SeniorCS" />

                            {/* 5 Things to Consider */}
                            <h2><Trans i18nKey="content.thingsToConsider.heading" ns="SeniorCS" /></h2>
                            <Trans i18nKey="content.thingsToConsider.description" ns="SeniorCS" />

                            {/* FAQ */}
                            <h2><Trans i18nKey="content.faq.heading" ns="SeniorCS" /></h2>
                            {t('content.faq.qa', { returnObjects: true }).map((faq, index) => (
                                <div key={index}>
                                    <h4><Trans i18nKey={`content.faq.qa.${index}.q`} ns="SeniorCS" /></h4>
                                    <p><Trans i18nKey={`content.faq.qa.${index}.a`} ns="SeniorCS" /></p>
                                </div>
                            ))}
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    );
};

export default SeniorCS;